export default "__VITE_ASSET__C0ZPgY$I__"